/* ============================================
   CELOPMAN — Lógica de tienda (Shopify)
   Carrito vía AJAX API + UI del boceto original
   ============================================ */

const CEL_I18N = window.CEL_I18N || {};
const CEL_T = {
  size: CEL_I18N.size || "Talla",
  remove: CEL_I18N.remove || "Eliminar",
  cart_empty: CEL_I18N.cart_empty || "Tu cesta está vacía.",
  discover: CEL_I18N.discover || "Descubrir productos",
  add_error: CEL_I18N.add_error || CEL_T.add_error,
};
const CEL_ROOT = (window.CEL_ROOT || "").replace(/\/+$/, "");
function celCart(p){ return CEL_ROOT + p; }

const STORE = {
  currency: "€",
  cart: null,
};

/* ---------- Utils ---------- */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

/* Shopify entrega los precios en céntimos */
const fmt = (cents) =>
  (cents / 100).toLocaleString("es-ES", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + STORE.currency;

/* ---------- CART (Shopify AJAX API) ---------- */
async function fetchCart() {
  const res = await fetch(celCart("/cart.js"), { headers: { Accept: "application/json" } });
  STORE.cart = await res.json();
  return STORE.cart;
}

async function apiAdd(variantId, qty = 1) {
  const res = await fetch(celCart("/cart/add.js"), {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.description || "No se pudo añadir a la cesta");
  }
  return res.json();
}

async function apiChange(key, quantity) {
  const res = await fetch(celCart("/cart/change.js"), {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: key, quantity }),
  });
  STORE.cart = await res.json();
  return STORE.cart;
}

async function addToCart(variantId, qty = 1, { open = true } = {}) {
  if (!variantId) return;
  try {
    await apiAdd(variantId, qty);
    await fetchCart();
    syncCartUI();
    if (open) openCart();
  } catch (e) {
    alert(e.message);
  }
}

async function changeQty(key, delta) {
  if (!STORE.cart) await fetchCart();
  const item = STORE.cart.items.find((i) => i.key === key);
  if (!item) return;
  await apiChange(key, Math.max(0, item.quantity + delta));
  syncCartUI();
}

async function removeFromCart(key) {
  await apiChange(key, 0);
  syncCartUI();
}

/* ---------- Render del drawer ---------- */
function syncCartUI() {
  updateCartCount();
  renderCartDrawer();
}

function updateCartCount() {
  const n = STORE.cart ? STORE.cart.item_count : 0;
  $$(".cart-count").forEach((el) => {
    el.textContent = n;
    el.style.display = n > 0 ? "flex" : "none";
  });
}

function renderCartDrawer() {
  const body = $("#cartBody");
  const foot = $("#cartFoot");
  if (!body || !foot) return;

  const cart = STORE.cart;
  if (!cart || !cart.items.length) {
    body.innerHTML = `<div class="cart-empty">${CEL_T.cart_empty}<br/><br/><a href="/collections/all" class="btn btn-dark" style="display:inline-flex">${CEL_T.discover}</a></div>`;
    foot.style.display = "none";
    return;
  }

  body.innerHTML = cart.items
    .map((i) => {
      const size = i.variant_title && i.variant_title !== "Default Title" ? ` · ${CEL_T.size} ${i.variant_title}` : "";
      return `
    <div class="cart-item" data-key="${i.key}">
      <img src="${i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_200x$1$2") : ""}" alt="${i.product_title}" loading="lazy"/>
      <div class="cart-item-info">
        <div>
          <h4>${i.product_title}</h4>
          <small>${i.product_type || ""}${size}</small>
        </div>
        <div class="qty-row">
          <button data-act="dec" data-key="${i.key}">−</button>
          <span>${i.quantity}</span>
          <button data-act="inc" data-key="${i.key}">+</button>
        </div>
      </div>
      <div class="cart-item-end">
        <strong>${fmt(i.final_line_price)}</strong>
        <button class="remove-btn" data-act="rm" data-key="${i.key}">${CEL_T.remove}</button>
      </div>
    </div>`;
    })
    .join("");

  foot.style.display = "block";
  const totalEl = $("#cartTotal");
  if (totalEl) totalEl.textContent = fmt(cart.total_price);
}

function openCart() {
  $("#cartDrawer")?.classList.add("is-open");
  document.body.style.overflow = "hidden";
}
function closeCart() {
  $("#cartDrawer")?.classList.remove("is-open");
  document.body.style.overflow = "";
}

/* ---------- Header ---------- */
function setupHeader({ transparentOnTop = false } = {}) {
  const header = $(".site-header");
  if (!header) return;
  if (transparentOnTop) header.classList.add("transparent");

  const onScroll = () => {
    if (window.scrollY > 40) {
      header.classList.add("scrolled");
      header.classList.remove("transparent");
    } else {
      header.classList.remove("scrolled");
      if (transparentOnTop) header.classList.add("transparent");
    }
  };
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });
}

/* ---------- Menú lateral ---------- */
function setupMobileNav() {
  const openBtn = $("#menuOpen");
  const closeBtn = $("#menuClose");
  const overlay = $("#menuOverlay");
  if (!openBtn || !overlay) return;

  const open = () => {
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  };

  openBtn.addEventListener("click", open);
  closeBtn?.addEventListener("click", close);
  $("#menuBackdrop")?.addEventListener("click", close);
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.classList.contains("is-open")) close();
  });

  overlay.querySelectorAll(".menu-expand").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = btn.dataset.expand;
      const sub = document.getElementById(`sub-${target}`);
      if (!sub) return;
      const isOpen = sub.classList.toggle("is-open");
      btn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });
}

/* ---------- Cart drawer ---------- */
function setupCartDrawer() {
  $$("[data-cart-open]").forEach((b) =>
    b.addEventListener("click", (e) => {
      e.preventDefault();
      openCart();
    })
  );
  $("#cartBackdrop")?.addEventListener("click", closeCart);
  $("#cartClose")?.addEventListener("click", closeCart);

  /* Delegación de inc/dec/eliminar (drawer y página de carrito) */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-act][data-key]");
    if (!btn) return;
    const onCartPage = !btn.closest("#cartBody");
    const k = btn.dataset.key;
    const a = btn.dataset.act;
    const run = a === "inc" ? changeQty(k, 1) : a === "dec" ? changeQty(k, -1) : removeFromCart(k);
    if (onCartPage) Promise.resolve(run).then(() => location.reload());
  });
}

/* ---------- Quick add / size add (tarjetas) ---------- */
function setupCardAdd() {
  document.addEventListener("click", (e) => {
    const quick = e.target.closest("[data-quick-add]");
    const sizeBtn = e.target.closest("[data-size-add]");
    if (quick) {
      e.preventDefault();
      e.stopPropagation();
      if (quick.disabled) return;
      addToCart(quick.dataset.variantId, 1);
    } else if (sizeBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (sizeBtn.disabled) return;
      addToCart(sizeBtn.dataset.variantId, 1);
    }
  });
}

/* ---------- Reveal on scroll ---------- */
function setupReveal() {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          en.target.classList.add("is-visible");
          io.unobserve(en.target);
        }
      });
    },
    { rootMargin: "-10% 0px" }
  );
  $$(".reveal").forEach((el) => io.observe(el));
}

/* ---------- Carrusel ---------- */
function setupCarousel(root) {
  if (!root) return;
  const track = $(".carousel-track", root);
  const prev = $("[data-carousel-prev]", root);
  const next = $("[data-carousel-next]", root);
  const progress = $("[data-carousel-progress]", root);
  if (!track) return;

  const cardWidth = () => track.querySelector(".product-card")?.getBoundingClientRect().width || 320;
  const gap = () => parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 22;
  const stepSize = () => cardWidth() + gap();

  const updateState = () => {
    const max = track.scrollWidth - track.clientWidth;
    const x = track.scrollLeft;
    prev && (prev.disabled = x <= 2);
    next && (next.disabled = x >= max - 2);
    if (progress) {
      const ratio = track.clientWidth / track.scrollWidth;
      const offset = max ? x / max : 0;
      progress.style.width = `${Math.min(100, ratio * 100)}%`;
      progress.style.transform = `translateX(${offset * (100 / ratio - 100)}%)`;
    }
  };

  prev?.addEventListener("click", () => track.scrollBy({ left: -stepSize(), behavior: "smooth" }));
  next?.addEventListener("click", () => track.scrollBy({ left: stepSize(), behavior: "smooth" }));
  track.addEventListener("scroll", updateState, { passive: true });
  window.addEventListener("resize", updateState);

  /* Drag-to-scroll */
  let isDown = false, startX = 0, startLeft = 0, moved = false;
  track.addEventListener("pointerdown", (e) => {
    if (e.target.closest("a, button")) return;
    isDown = true; moved = false;
    startX = e.clientX; startLeft = track.scrollLeft;
    track.classList.add("is-dragging");
    track.setPointerCapture(e.pointerId);
  });
  track.addEventListener("pointermove", (e) => {
    if (!isDown) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 4) moved = true;
    track.scrollLeft = startLeft - dx;
  });
  const endDrag = (e) => {
    if (!isDown) return;
    isDown = false;
    track.classList.remove("is-dragging");
    try { track.releasePointerCapture(e.pointerId); } catch (_) {}
  };
  track.addEventListener("pointerup", endDrag);
  track.addEventListener("pointercancel", endDrag);
  track.addEventListener("pointerleave", endDrag);
  track.addEventListener("click", (e) => {
    if (moved) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  requestAnimationFrame(updateState);
}

function setupAllCarousels() {
  $$(".featured-carousel").forEach(setupCarousel);
  $$(".pdp-related").forEach(setupCarousel);
}

/* ---------- Galería deslizable de la tarjeta ---------- */
function setupCardGalleries() {
  $$("[data-card-gallery]").forEach((g) => {
    if (g.dataset.galleryInit) return;
    g.dataset.galleryInit = "1";
    const count = g.children.length;
    if (count < 2) return;
    const media = g.parentElement;
    const progress = media.querySelector(".card-progress");
    const bar = media.querySelector(".card-progress-bar");
    const prev = media.querySelector(".card-nav--prev");
    const next = media.querySelector(".card-nav--next");
    const step = () => g.clientWidth || 1;
    let idleTimer;

    const update = () => {
      const i = Math.round(g.scrollLeft / step());
      if (bar) bar.style.width = ((i + 1) / count) * 100 + "%";
    };

    prev && prev.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); g.scrollBy({ left: -step(), behavior: "smooth" }); });
    next && next.addEventListener("click", (e) => { e.preventDefault(); e.stopPropagation(); g.scrollBy({ left: step(), behavior: "smooth" }); });
    g.addEventListener("scroll", () => {
      update();
      if (progress) {
        progress.classList.add("is-scrolling");
        clearTimeout(idleTimer);
        idleTimer = setTimeout(() => progress.classList.remove("is-scrolling"), 700);
      }
    }, { passive: true });
    update();
  });
}

/* ---------- Acordeones (FAQ, producto, tiendas) ---------- */
function setupAccordions() {
  $$(".accordion-head").forEach((h) =>
    h.addEventListener("click", () => h.closest(".accordion-item").classList.toggle("open"))
  );
}

/* ---------- Infinite scroll de colección ---------- */
function setupInfiniteScroll() {
  const grid = $("#shopGrid");
  const container = $("[data-infinite]");
  if (!grid || !container) return;

  let loading = false;
  let done = false;

  async function loadMore() {
    const btn = container.querySelector("[data-load-more]");
    if (!btn || loading || done) return;
    loading = true;
    const url = btn.getAttribute("href");
    btn.textContent = "Cargando…";
    try {
      const res = await fetch(url, { headers: { "X-Requested-With": "fetch" } });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");
      doc.querySelectorAll("#shopGrid > .product-card").forEach((c) => grid.appendChild(c));
      const nextBtn = doc.querySelector("[data-load-more]");
      if (nextBtn) {
        btn.setAttribute("href", nextBtn.getAttribute("href"));
        btn.textContent = "Cargar más";
      } else {
        done = true;
        container.remove();
        io && io.disconnect();
      }
      setupCardGalleries();
    } catch (e) {
      btn.textContent = "Cargar más";
    }
    loading = false;
  }

  container.querySelector("[data-load-more]")?.addEventListener("click", (e) => {
    e.preventDefault();
    loadMore();
  });

  const io = new IntersectionObserver(
    (entries) => entries.forEach((en) => { if (en.isIntersecting) loadMore(); }),
    { rootMargin: "700px 0px" }
  );
  io.observe(container);
}

/* ---------- Footer plegable en móvil ---------- */
function setupFooterAccordion() {
  $$(".footer-col--links h5").forEach((h) => {
    h.addEventListener("click", () => {
      if (window.innerWidth > 749) return;
      h.closest(".footer-col--links").classList.toggle("is-open");
    });
  });
}

/* ---------- Modal "Próximamente disponible" ---------- */
function setupComingSoon() {
  const modal = document.getElementById("comingSoonModal");
  if (!modal) return;
  const open = () => { modal.classList.add("is-open"); document.body.style.overflow = "hidden"; };
  const close = () => { modal.classList.remove("is-open"); document.body.style.overflow = ""; };
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-coming-soon]")) { e.preventDefault(); open(); }
    else if (e.target.closest("[data-cs-close]")) { close(); }
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) close();
  });
}

/* ---------- Preferencias de cookies (Shopify) ---------- */
function setupCookiePreferences() {
  document.addEventListener("click", function (e) {
    const a = e.target.closest('a[href="#cookie-preferences"]');
    if (!a) return;
    e.preventDefault();
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === "function") {
        window.privacyBanner.showPreferences();
      } else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openPreferences === "function") {
        window.Shopify.customerPrivacy.openPreferences();
      } else {
        window.location.href = "/pages/politicas-de-cookies";
      }
    } catch (err) {
      window.location.href = "/pages/politicas-de-cookies";
    }
  });
}

/* ---------- Centrar el chip activo en la barra de colecciones ---------- */
function setupActiveChip() {
  const wrap = document.getElementById("filterChips");
  if (!wrap) return;
  const active = wrap.querySelector(".chip.active");
  if (!active) return;
  const offset = active.offsetLeft - wrap.clientWidth / 2 + active.offsetWidth / 2;
  wrap.scrollLeft = Math.max(0, offset);
}

/* ---------- Orden en colección ---------- */
function setupSort() {
  const sel = $("[data-sort-select]");
  if (!sel) return;
  sel.addEventListener("change", () => {
    const url = new URL(location.href);
    url.searchParams.set("sort_by", sel.value);
    url.searchParams.delete("page");
    location.href = url.toString();
  });
}

/* ---------- PDP ---------- */
function setupPdpLightbox(galleryEl, slides) {
  const lb = $("#pdpLightbox");
  if (!lb || !slides.length) return;

  const lbImg = $("#lbImg");
  const lbStage = $("#lbStage");
  const prevBtn = $("#lbPrev");
  const nextBtn = $("#lbNext");
  const closeBtn = $("#lbClose");
  let current = 0;

  const show = (i) => {
    current = ((i % slides.length) + slides.length) % slides.length;
    lbImg.src = slides[current];
    lbImg.alt = `Imagen ${current + 1}`;
    lbStage.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };
  const open = (i) => {
    show(i);
    lb.classList.add("is-open", "is-zoomed");
    document.body.classList.add("pdp-lightbox-open");
  };
  const close = () => {
    lb.classList.remove("is-open", "is-zoomed");
    document.body.classList.remove("pdp-lightbox-open");
  };
  const toggleZoom = (e) => {
    const wasZoomed = lb.classList.contains("is-zoomed");
    lb.classList.toggle("is-zoomed");
    if (!wasZoomed && e) {
      requestAnimationFrame(() => {
        const w = lbImg.naturalWidth, h = lbImg.naturalHeight;
        const r = lbStage.getBoundingClientRect();
        const xR = (e.clientX - r.left) / r.width;
        const yR = (e.clientY - r.top) / r.height;
        lbStage.scrollTo({ left: Math.max(0, w * xR - r.width / 2), top: Math.max(0, h * yR - r.height / 2), behavior: "auto" });
      });
    }
  };

  galleryEl.querySelectorAll(".gallery-slide").forEach((s, i) => {
    s.addEventListener("click", (e) => { e.preventDefault(); open(i); });
  });
  prevBtn.addEventListener("click", (e) => { e.stopPropagation(); show(current - 1); });
  nextBtn.addEventListener("click", (e) => { e.stopPropagation(); show(current + 1); });
  closeBtn.addEventListener("click", (e) => { e.stopPropagation(); close(); });
  $("#lbZoom")?.addEventListener("click", (e) => { e.stopPropagation(); toggleZoom(); });
  lbImg.addEventListener("click", toggleZoom);
  lbStage.addEventListener("click", (e) => { if (e.target === lbStage) close(); });
  document.addEventListener("keydown", (e) => {
    if (!lb.classList.contains("is-open")) return;
    if (e.key === "Escape") close();
    else if (e.key === "ArrowLeft") show(current - 1);
    else if (e.key === "ArrowRight") show(current + 1);
  });
}

function initProduct() {
  const galleryEl = $("#pGallery");
  if (!galleryEl) return;

  /* Flechas galería */
  const prevBtn = $("#pdpPrev");
  const nextBtn = $("#pdpNext");
  const slideWidth = () => galleryEl.querySelector(".gallery-slide")?.getBoundingClientRect().width || 400;
  const gap = () => parseFloat(getComputedStyle(galleryEl).columnGap || getComputedStyle(galleryEl).gap) || 4;
  const step = () => slideWidth() + gap();
  const updateGalleryState = () => {
    const max = galleryEl.scrollWidth - galleryEl.clientWidth;
    const x = galleryEl.scrollLeft;
    if (prevBtn) prevBtn.disabled = x <= 2;
    if (nextBtn) nextBtn.disabled = x >= max - 2;
  };
  prevBtn?.addEventListener("click", () => galleryEl.scrollBy({ left: -step(), behavior: "smooth" }));
  nextBtn?.addEventListener("click", () => galleryEl.scrollBy({ left: step(), behavior: "smooth" }));
  galleryEl.addEventListener("scroll", updateGalleryState, { passive: true });
  window.addEventListener("resize", updateGalleryState);
  requestAnimationFrame(updateGalleryState);

  /* Lightbox: usa imágenes a tamaño completo */
  const slides = $$(".gallery-slide", galleryEl).map((s) => s.dataset.full || s.querySelector("img")?.src).filter(Boolean);
  setupPdpLightbox(galleryEl, slides);

  /* Selección de talla → variante */
  const sizesEl = $("#pSizes");
  const variantInput = $("#pVariantId");
  if (sizesEl) {
    sizesEl.addEventListener("click", (e) => {
      const b = e.target.closest(".size-pill");
      if (!b || b.disabled || b.dataset.soldout) return;
      sizesEl.querySelectorAll(".size-pill").forEach((x) => x.classList.toggle("active", x === b));
      if (variantInput && b.dataset.variantId) variantInput.value = b.dataset.variantId;
    });
  }

  /* Añadir a la cesta (submit del form de producto) */
  const form = $("#productForm");
  form?.addEventListener("submit", (e) => {
    e.preventDefault();
    let activeBtn = sizesEl?.querySelector(".size-pill.active");
    if (sizesEl && !activeBtn) {
      activeBtn = sizesEl.querySelector(".size-pill:not([disabled]):not([data-soldout])");
      activeBtn?.classList.add("active");
      if (activeBtn && variantInput) variantInput.value = activeBtn.dataset.variantId;
    }
    const variantId = variantInput?.value;
    addToCart(variantId, 1);
  });

  /* Barra de compra sticky */
  const pdpBar = $("#pdpBar");
  if (pdpBar) {
    const gallerySection = $(".pdp-gallery");
    const updateBar = () => {
      const triggerY = gallerySection ? gallerySection.getBoundingClientRect().bottom : 200;
      pdpBar.classList.toggle("is-visible", triggerY < window.innerHeight - 40);
    };
    window.addEventListener("scroll", updateBar, { passive: true });
    window.addEventListener("resize", updateBar);
    requestAnimationFrame(updateBar);
  }
}

/* ---------- Boot ---------- */
document.addEventListener("DOMContentLoaded", async () => {
  const isHome = document.body.classList.contains("template-index");
  setupHeader({ transparentOnTop: isHome });
  setupMobileNav();
  setupCartDrawer();
  setupCardAdd();
  setupReveal();
  setupAllCarousels();
  setupCardGalleries();
  setupInfiniteScroll();
  setupAccordions();
  setupCookiePreferences();
  setupComingSoon();
  setupFooterAccordion();
  setupActiveChip();
  setupSort();
  initProduct();

  await fetchCart();
  syncCartUI();
});
